"use strict";

var _interopRequireDefault = require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.find");
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _configure = require("@/api/configure.js");
var _dictionary = require("@/config/dictionary");
var _Tinymce = _interopRequireDefault(require("@/components/Tinymce"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'courtVedioSource',
  data: function data() {
    return {
      tableHeaderColor: this.$tableHeaderColor,
      groupUserLoading: false,
      committeeValue: '',
      //所属仲裁委值
      committeeArr: [],
      arbitrationArr: [],
      loading: true,
      tableData: [],
      abirtGridData: [],
      currentPage: 1,
      pageLimit: 10,
      //每页请求多少个数据，默认10
      pageSizes: this.$tablePageSizes,
      total: 0,
      channelType: _dictionary.dictionary.channelType,
      channelState: _dictionary.dictionary.channelState,
      sourceVisible: false,
      //弹窗显示
      groupUserVisible: false,
      abirtUserVisible: false,
      groupUserForm: {
        id: null,
        ylUserId: null,
        name: '',
        ylGroupId: null,
        type: '',
        mobile: '',
        ylTitle: '',
        sysUserId: null,
        gender: ''
      },
      temForm: {
        //数据
        id: null,
        commId: '',
        ylGroupName: '',
        ylGroupId: '',
        discipline: ''
      },
      temFormRules: {
        commId: [{
          required: true,
          message: '请选择仲裁委'
        }],
        discipline: [{
          required: true,
          message: '请填写庭审纪律'
        }]
      },
      groupUserFormRules: {
        sysUserId: [{
          required: true,
          message: '请选择仲裁员'
        }]
      }
    };
  },
  components: {
    Tinymce: _Tinymce.default
  },
  created: function created() {
    var _this = this;
    this.currentPage = 1;
    this.init();
    //仲裁委员会列表
    (0, _configure.getAllCommission)().then(function (res) {
      if (res.code == 1) {
        _this.committeeArr = res.data;
      } else {
        _this.$message({
          message: res.msg,
          type: 'error'
        });
      }
    });
  },
  mounted: function mounted() {},
  methods: {
    // 初始化
    init: function () {
      var _init = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var _yield$getTrialYlGrou, rows, total;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _configure.getTrialYlGroupList)({
                limit: this.pageLimit,
                page: this.currentPage
              });
            case 2:
              _yield$getTrialYlGrou = _context.sent;
              rows = _yield$getTrialYlGrou.rows;
              total = _yield$getTrialYlGrou.total;
              this.tableData = rows;
              this.total = total;
              this.loading = false;
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }(),
    //重置列表
    resetTableList: function () {
      var _resetTableList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var _yield$getTrialYlGrou2, rows, total, _yield$getTrialYlGrou3, _rows, _total;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(this.statevalue || this.committeeValue)) {
                _context2.next = 11;
                break;
              }
              _context2.next = 3;
              return (0, _configure.getTrialYlGroupList)({
                commId: this.committeeValue,
                state: this.statevalue,
                limit: this.pageLimit,
                page: this.currentPage
              });
            case 3:
              _yield$getTrialYlGrou2 = _context2.sent;
              rows = _yield$getTrialYlGrou2.rows;
              total = _yield$getTrialYlGrou2.total;
              this.tableData = rows;
              this.total = total;
              this.loading = false;
              _context2.next = 19;
              break;
            case 11:
              _context2.next = 13;
              return (0, _configure.getTrialYlGroupList)({
                limit: this.pageLimit,
                page: this.currentPage
              });
            case 13:
              _yield$getTrialYlGrou3 = _context2.sent;
              _rows = _yield$getTrialYlGrou3.rows;
              _total = _yield$getTrialYlGrou3.total;
              this.tableData = _rows;
              this.total = _total;
              this.loading = false;
            case 19:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function resetTableList() {
        return _resetTableList.apply(this, arguments);
      }
      return resetTableList;
    }(),
    //筛选
    screen: function () {
      var _screen = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var _yield$getTrialYlGrou4, rows, total, _yield$getTrialYlGrou5, _rows2, _total2;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.total = 1;
              this.currentPage = 1;
              if (!(this.statevalue != null || this.committeeValue)) {
                _context3.next = 13;
                break;
              }
              _context3.next = 5;
              return (0, _configure.getTrialYlGroupList)({
                commId: this.committeeValue,
                state: this.statevalue,
                limit: this.pageLimit,
                page: this.currentPage
              });
            case 5:
              _yield$getTrialYlGrou4 = _context3.sent;
              rows = _yield$getTrialYlGrou4.rows;
              total = _yield$getTrialYlGrou4.total;
              this.tableData = rows;
              this.total = total;
              this.loading = false;
              _context3.next = 21;
              break;
            case 13:
              _context3.next = 15;
              return (0, _configure.getTrialYlGroupList)({
                limit: this.pageLimit,
                page: this.currentPage
              });
            case 15:
              _yield$getTrialYlGrou5 = _context3.sent;
              _rows2 = _yield$getTrialYlGrou5.rows;
              _total2 = _yield$getTrialYlGrou5.total;
              this.tableData = _rows2;
              this.total = _total2;
              this.loading = false;
            case 21:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function screen() {
        return _screen.apply(this, arguments);
      }
      return screen;
    }(),
    //点击 清空所有筛选条件
    clearAllConditon: function clearAllConditon() {
      this.statevalue = '';
      this.committeeValue = "";
      this.currentPage = 1;
      this.init();
    },
    // 分页事件
    handleSizeChange: function handleSizeChange(val) {
      this.pageLimit = val;
      this.resetTableList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.resetTableList();
    },
    //删除
    deleteRow: function deleteRow(val) {
      var _this2 = this;
      this.$confirm('是否删除该用户组？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _configure.deleteTrialYlGroupById)(val.id).then(function (res) {
          if (res.code == 1) {
            _this2.$message({
              message: '删除成功',
              type: 'success'
            });
            _this2.resetTableList();
          } else {
            _this2.$message({
              message: res.msg,
              type: 'error'
            });
          }
        });
      }).catch(function () {
        _this2.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //修改
    edit: function edit(val) {
      var _this3 = this;
      this.sourceVisible = true;
      (0, _configure.getTrialYlGroupById)(val.id).then(function (res) {
        if (res.code == 1) {
          _this3.temForm = res.data;
        } else {
          _this3.$message({
            message: res.msg,
            type: 'error'
          });
        }
      });
    },
    addUser: function addUser(val) {
      var _this4 = this;
      this.groupUserVisible = true;
      this.groupUserForm = {
        //数据
        sysUserId: null,
        ylGroupId: val.id,
        name: ''
      };
      (0, _configure.selectArbitratorInfo)({
        commId: val.commId
      }).then(function (res) {
        if (res.code == 1) {
          _this4.arbitrationArr = res.data;
        } else {
          _this4.$message({
            message: res.msg,
            type: 'error'
          });
          _this4.arbitrationArr = [];
        }
      });
    },
    gotoCreate: function gotoCreate() {
      this.sourceVisible = true;
      this.temForm = {
        //数据
        commId: '',
        ylGroupName: '',
        ylGroupId: '',
        discipline: ''
      };
    },
    submitForm: function submitForm(formName) {
      var _this5 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          var committeeItem = _this5.committeeArr.find(function (ele) {
            return ele.id == _this5.temForm.commId;
          });
          _this5.temForm.ylGroupName = committeeItem.name;
          _this5.groupUserLoading = true;
          if (_this5.temForm.id) {
            (0, _configure.editDiscipline)(_this5.temForm).then(function (res) {
              if (res.code == 1) {
                _this5.$message({
                  message: '修改成功',
                  type: 'success'
                });
                _this5.sourceVisible = false;
                _this5.$refs[formName].resetFields();
                _this5.resetTableList();
              } else {
                _this5.$message({
                  message: res.msg,
                  type: 'error'
                });
              }
            });
          } else {
            (0, _configure.saveTrialYlGroup)(_this5.temForm).then(function (res) {
              if (res.code == 1) {
                _this5.$message({
                  message: '添加成功',
                  type: 'success'
                });
                _this5.sourceVisible = false;
                _this5.$refs[formName].resetFields();
                _this5.resetTableList();
              } else {
                _this5.$message({
                  message: res.msg,
                  type: 'error'
                });
              }
            });
          }
          _this5.groupUserLoading = false;
        } else {
          return false;
        }
      });
    },
    submitUserForm: function submitUserForm(formName) {
      var _this6 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this6.groupUserLoading = true;
          (0, _configure.groupAddUser)(_this6.groupUserForm).then(function (res) {
            if (res.code == 1) {
              _this6.$message({
                message: '修改成功',
                type: 'success'
              });
              _this6.groupUserVisible = false;
              _this6.$refs[formName].resetFields();
              _this6.resetTableList();
            } else {
              _this6.$message({
                message: res.msg,
                type: 'error'
              });
            }
          });
          _this6.groupUserLoading = false;
        } else {
          return false;
        }
      });
    },
    groupUserChange: function groupUserChange(val) {
      var arbitrationItem = this.arbitrationArr.find(function (ele) {
        return ele.id == val;
      });
      if (arbitrationItem) {
        this.groupUserForm.mobile = arbitrationItem.mobile;
        this.groupUserForm.email = arbitrationItem.email;
        this.groupUserForm.gender = arbitrationItem.sex;
        this.groupUserForm.name = arbitrationItem.name;
      }
    },
    getUserList: function getUserList(val) {
      var _this7 = this;
      (0, _configure.selectGroupUserList)(val.id).then(function (res) {
        if (res.code == 1) {
          console.log(res.data);
          _this7.abirtGridData = res.data;
          _this7.abirtUserVisible = true;
        } else {
          _this7.$message({
            message: res.msg,
            type: 'error'
          });
        }
      });
    },
    deleteUserRow: function deleteUserRow(val) {
      var _this8 = this;
      this.$confirm('是否删除该用户吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _configure.deleteGroupUserById)(val.id).then(function (res) {
          if (res.code == 1) {
            _this8.$message({
              message: '删除成功',
              type: 'success'
            });
            _this8.getUserList({
              id: val.ylGroupId
            });
          } else {
            _this8.$message({
              message: res.msg,
              type: 'error'
            });
          }
        });
      }).catch(function () {
        _this8.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    }
  }
};
exports.default = _default;